////////////// JQUERY CONFLICT NO PLEASE

(function ($) {


    ///////////////////////////////////
    ///////     FUNCTIONS     /////////
    ///////////////////////////////////

    // debug
    window.debug = window.debug || function (log) {
        if (typeof (log) === 'undefined') return;
        if ((typeof (window.console) !== 'undefined') && (typeof (console.log) === 'function')) {
            console.log(log);
        }
    };

    // callback helper
    window.callback_all = window.callback_all || function (jQueryEl, cback) {
        var counter = 0;
        return function () {
            counter++;
            if (counter < jQueryEl.length) return;
            cback();
        }
    };

    // check if object is empty
    window.isEmpty = function (obj) {

        // null and undefined are "empty"
        if (obj == null) return true;

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") return true;

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }

        return true;
    };

    // Main slideshow
    window.detectIE = window.detectIE || function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
    };

    /*  concat values offering */
    window.concatValues = window.concatValues || function (obj) {
        var value = '';
        for (var prop in obj) {
            value += obj[prop];
        }
        return value;
    };

    // check for mobiles and tablets
    window.refresh_size_queries = window.refresh_size_queries || function () {
        var classes = [];
        var window_width = jQuery(window).width();
        var window_height = jQuery(window).height();

        window.is_phone = (window_width < 768);
        // window.is_phone = (window.matchMedia("(max-width: 767px)").matches);
        window.is_mobile = (window_width < 992);
        // window.is_mobile = (window.matchMedia("(max-width: 991px)").matches);
        window.is_tablet_portrait = (window_width >= 768 && window_width < 992);
        // window.is_tablet_portrait = (window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches);
        window.is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        // window.is_tablet_landscape = (window.matchMedia("(min-width: 768px) and (max-width: 991px and max-height: 768px)").matches);
        // window.is_tablet = is_tablet_portrait || is_tablet_landscape;
        window.is_desktop = (window_width >= 992);
        // window.is_desktop = (window.matchMedia("(min-width: 992px)").matches);
        window.is_desktop_large = (window_width >= 1200);
        // window.is_large_desktop = (window.matchMedia("(min-width: 1200px)").matches);

        if (window.is_phone) {
            classes.push('mq_phone');
        }
        if (window.is_mobile) {
            classes.push('mq_mobile');
        }
        if (window.is_tablet_portrait) {
            classes.push('mq_tablet_portrait');
        }
        if (window.is_tablet_landscape) {
            classes.push('mq_tablet_landscape');
        }
        if (window.is_tablet) {
            classes.push('mq_tablet');
        }

        jQuery('html')
            .removeClass('mq_phone')
            .removeClass('mq_mobile')
            .removeClass('mq_tablet_portrait')
            .removeClass('mq_tablet_landscape')
            .removeClass('mq_tablet')
            .addClass(classes.join(' '));
    };

    //  openclose content
    window.open_close_viewmore = window.open_close_viewmore || function () {
        var btns = $('.view_more_content');
        btns.each(function () {
            // this
            var anchor = $(this);
            anchor.on('click tap', function (e) {
                e.stopPropagation();
                var anchor = $(this);
                var div_id = anchor.data('id');
                // id optional
                var more_text_box = (typeof div_id !== 'undefined') ? $('#' + div_id) : $(this).parent().find('.more_text_box');
                // reset
                if (typeof div_id === 'undefined') {
                    var more_text_box_opened = $('.more_text_box.opened');
                    if (more_text_box_opened.length > 0) {
                        more_text_box_opened.stop().animate({height: 0}, 300, function () {
                            more_text_box_opened.parent().find('.view_more_content').removeClass('opened');
                            more_text_box_opened.removeClass('opened');
                        });
                    }
                }
                if ($(this).hasClass('opened')) {
                    more_text_box.stop().animate({height: 0}, 300, function () {
                        anchor.removeClass('opened');
                        more_text_box.removeClass('opened');
                    });
                } else {
                    var customHeight = more_text_box.find('.more_text').outerHeight(true);
                    more_text_box.stop().animate({height: customHeight}, 300, function () {
                        anchor.addClass('opened');
                        more_text_box.addClass('opened');
                    });
                }
                //close on btn
                more_text_box.find('.close').on('click tap', function () {
                    more_text_box.stop().animate({height: 0}, 300, function () {
                        anchor.removeClass('opened');
                        more_text_box.removeClass('opened');
                    });
                });
            });
        });
    };

    // simple open close
    window.simple_open_close = window.simple_open_close || function (btn) {
        // check
        if (typeof btn === 'undefined' || $(btn).length === 0) return false;
        //
        $(btn).on('click', function (e) {
            e.stopPropagation();
            var anchor = $(this);
            var div_id = anchor.data('id');
            var more_text_box = $('#' + div_id);
            // check
            if (typeof div_id === 'undefined' || more_text_box.length === 0) return false;
            //
            if (!more_text_box.hasClass('visible')) {
                anchor.addClass('open');
                more_text_box.addClass('visible');
            } else {
                anchor.removeClass('open');
                more_text_box.removeClass('visible');
            }
        });
    };

    // mobile view more
    window.mobile_view_more = window.mobile_view_more || function () {
        // vars
        var btns = jQuery('a.read_more_mobile');
        // checks
        if (btns.length === 0) return false;
        btns.each(function () {
            var btn = $(this);
            var nextall = btn.closest('p').nextAll();
            // console.log(nextall);
            var wrappers = $('<span class="mobile_hidden_box"><span class="mobile_hidden_content"></span></span>');
            nextall.appendTo(wrappers.find('.mobile_hidden_content'));
            wrappers.insertBefore(btn);

            // btn.nextAll().wrap('<span class="1">').wrap('<span class="2">');
            btn.on('click', function () {
                var body = $(this).closest('div');
                var box = body.find('.mobile_hidden_box');
                var content = box.find('.mobile_hidden_content');
                // check
                if (content.length === 0) return false;
                // check h
                var h = content.outerHeight(true);
                box.stop().animate({height: h}, 300, function () {
                    btn.remove();
                });
            });
        });
    };

    // selects
    window.select_dd = window.select_dd || function (param) {
        // vars
        var select_wrappers = $('.select-wrapper');
        // check
        if (select_wrappers.length === 0) return false;
        // select wrappers
        select_wrappers.each(function () {
            var sel_wrap = $(this);
            var sel_input = sel_wrap.data('inputname');
            var sel_callback = sel_wrap.data('callback');
            var sel_label = sel_wrap.find('.select-label');
            var sel_dbox = sel_wrap.find('.select-dropdown-box');
            var sel_d = sel_wrap.find('.select-dropdown');
            var sel_opts = sel_wrap.find('.select-option');
            sel_label.on('click tap', function () {
                // debug($(this));
                if (sel_wrap.hasClass('opened')) {
                    // debug('close');
                    sel_dbox.animate({
                        height: 0
                    }, 300, function () {
                        sel_wrap.removeClass('opened');
                    });
                } else {
                    // debug('open');
                    // i want to check
                    var h = sel_d.outerHeight();
                    // if the top of the dd menu goes upper than i scroll (minus header) i want that down
                    if (parseInt(sel_wrap.offset().top - h, 10) < parseInt(jQuery(window).scrollTop() + jQuery('#header').outerHeight(), 10)) {
                        sel_wrap.addClass('below');
                    } else {
                        // debug('remove below');
                        sel_wrap.removeClass('below');
                    }
                    sel_dbox.animate({
                        height: h
                    }, 300, function () {
                        sel_wrap.addClass('opened');
                    });
                }
            });
            sel_opts.each(function () {
                $(this).on('click', function () {
                    // reset class
                    sel_d.find('.active').removeClass('active');
                    // take value
                    var val = $(this).data('value');
                    // put value on label
                    sel_label.html('<span>' + $(this).html() + '</span>');
                    // add class
                    $(this).addClass('active');
                    // animate menu
                    sel_dbox.animate({
                        height: 0
                    }, 300, function () {
                        // put value in inputs
                        var input = $('input[name=' + sel_input + ']');
                        if (input.length > 0) {
                            input.val(val);
                        }
                        var select = $('select[name=' + sel_input + ']');
                        if (select.length > 0) {
                            select.val(val).trigger('change');
                        }
                        sel_wrap.removeClass('opened');
                    });
                    // check if it exist and fire it
                    if (typeof (window[sel_callback]) !== 'undefined') {
                        window[sel_callback](sel_d, val, $(this));
                    }
                });
            });
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.select-wrapper').length
                // && !$(event.target).closest('#inline-datepicker_placeholder').length
                // && !$(event.target).closest('#booking_form_placeholder .dates').length
            ) {
                // let's close it
                select_wrappers.each(function () {
                    var select_wrapper = $(this);
                    if (select_wrapper.hasClass('opened')) {
                        var sel_dbox = select_wrapper.find('.select-dropdown-box');
                        // debug('close');
                        sel_dbox.animate({
                            height: 0
                        }, 300, function () {
                            select_wrapper.removeClass('opened');
                        });
                    }
                });
            }
        });
    };

    // tabs managament
    window.select_tabs = window.select_tabs || function () {
        // box_tabs box_tab sel_tab
        var box_tabs = jQuery('.box_tabs');
        // check
        if (box_tabs.length === 0) return false;
        // multiple
        box_tabs.each(function () {
            // vars
            var wrapper = $(this);
            var btns = wrapper.find('.sel_tab');
            // on clickssss
            btns.on('click', function () {
                // var
                var btn = $(this);
                // check if i have class i came backkkk
                if (btn.hasClass('active')) return false;
                // reset btns
                wrapper.find('.sel_tab.active').removeClass('active');
                // make it active
                btn.addClass('active');
                // data from button
                var data_tab = btn.data('tab');
                var tab_callback = btn.data('tab_callback');
                // reset
                wrapper.find('.box_tab.active').removeClass('active');
                // let's active the tab
                var tab_to_open = wrapper.find('.box_tab.' + data_tab);
                tab_to_open.addClass('active');
                // check if it exist and fire it
                if (typeof (window[tab_callback]) !== 'undefined') {
                    window[tab_callback](tab_to_open, $(this));
                }
            });
        });
    };

    // scrolling
    window.scroll_to = window.scroll_to || function (param, offset) {
        var top = 0;
        if (typeof (param) == 'string') {
            var target = jQuery(param);
            if (target.length) {
                top = target.offset().top;
            }
        } else if (typeof (param) == 'number') {
            top = param;
        }
        //
        if (typeof offset !== 'undefined') {
            top = top - offset;
        }
        window.scrollFromJQuery = true;
        jQuery('html,body').stop(true).animate(
            {
                scrollTop: top - $('#header').outerHeight() + 1
            },
            500,
            'swing',
            function () {
                window.scrollFromJQuery = false;
            }
        );
    };

    // scroll to anchor
    window.btn_scroll = window.btn_scroll || function () {
        var btns = $('.scroll_to');
        if (btns.length === 0) return false;
        btns.each(function () {
            var btn = $(this);
            btn.on('click', function (e) {
                e.preventDefault();
                var hash = $(this).attr('href');
                if ($(hash).length === 0) return false;
                setTimeout(function () {
                    $('html,body').animate({
                        scrollTop: $(hash).offset().top - ($('#header').outerHeight() + $('#hotel_menu').outerHeight())
                    }, 1000);
                }, 100);
            });
        });
    };

    window.sameHeightForAllElements = window.sameHeightForAllElements || function (items, outerHeight) {
        if ($(items).size() > 0) {
            var max_height = 0;
            $(items).each(function (k, item) {
                var height = $(item).outerHeight(outerHeight);
                if (height > max_height) {
                    max_height = height;
                }
            });
            $(items).each(function (k, item) {
                $(item).css({
                    'height': max_height
                }).addClass('modified_height');
            });

        }
    };

    // lazy hand made
    window.lazy_hand = window.lazy_hand || function () {
        // vars
        var lazy_elems = jQuery('.lazy');

    };

    ///////////////////////////////////
    //////// THEME FUNCTIONS //////////
    ///////////////////////////////////

    ////////////////////////////////////////////////////////
    // COMMONS
    ////////////////////////////////////////////////////////

    // close fancy
    window.close_fancy = window.close_fancy || function () {
        jQuery.fancybox.close();
    };

    // creating breakpoints
    window.create_breakpoint = window.create_breakpoint || function () {
        // check
        if (typeof sshow_image_sizes === 'undefined' || sshow_image_sizes.length === 0) return false;
        // vars
        var breakpoints = [];
        var current_breakpoint = 'max';
        var sizes = sshow_image_sizes;
        var ww = $(window).width();
        //
        for (var i in sizes) {
            if (sizes.hasOwnProperty(i)) {
                if (i !== 'default' && i !== 'max') {
                    breakpoints.push(parseInt(i, 10));
                }
            }
        }
        if (breakpoints.length > 0) {
            breakpoints.sort(function (a, b) {
                return a - b;
            });
            for (var k = 0; k < breakpoints.length; k++) {
                if (ww <= breakpoints[k]) {
                    current_breakpoint = breakpoints[k];
                    break;
                }
            }
        }
        return current_breakpoint;
    };

    // Post-loads images and starts slideshow
    window.doSlideshow = window.doSlideshow || function (imagesContainerSelector) {
        // vars
        var sshow = jQuery(imagesContainerSelector);
        // checks
        if (typeof sshow === 'undefined' || sshow.size() === 0) return false;
        if (typeof (sshow_image_data) === 'undefined' || sshow_image_data.length === 0) return false;
        // config
        var ss_speed = (typeof (sspeed) !== 'undefined' && jQuery.trim(sspeed) !== '') ? sspeed : 2000;
        var ss_timeout = (typeof (stimeout) !== 'undefined' && jQuery.trim(stimeout) !== '') ? stimeout : 5000;
        //
        var loading = jQuery('.loading_sshow');
        // calculating size
        var current_breakpoint = window.create_breakpoint();

        // bind the mouseenter <- big fail to comment it...
        // $(window).on('mouseenter',function(){
        // console.log(sshow_image_data);
        // attaching images
        $.each(sshow_image_data, function (index, imgset) {
            //Check if is special offers page
            if ($('html').hasClass('special_offers')) {
                var id = imgset['ID'][0];
                var highlight_offer_title = imgset['title'];
                var highlight_offer_subtitle = imgset['subtitle'];
                var highlight_offer_excerpt = imgset['excerpt'];
                var highlight_offer_link = imgset['link'];
                var slider = jQuery('<div class="slide" data-title="' + highlight_offer_title + '" />');
                var img_cont = jQuery('<div class="slide_hlight_offer">' +
                    '<div class="highlight_offer_thumb_box" style="background-image: url(' + id + ')"></div><div class="highlight-container"><span class="main_title">' + highlight_offer_title +
                    '</span><span class="main_subtitle">' +
                    highlight_offer_subtitle + '</span><div class="highlight-content">' + highlight_offer_excerpt + '<a class="more" href="' + highlight_offer_link + '">' + read_more + '</a></div></span>');
                // appending img
                slider.append(img_cont);
            } else {
                // config
                var gallery_button = '';
                // images set
                var urls = imgset['url_set'];
                // do the other images
                var id = imgset['ID'];
                var img = jQuery('<img />').attr('src', imgset['url_set']['max']).attr('alt', imgset['title']);
                var slider = jQuery('<div class="slide" data-id="' + id + '" />');
                var img_cont = jQuery('<div class="slide_image">');
                if (typeof imgset['alt_text'] !== 'undefined' && imgset['alt_text'] !== '') {
                    img_cont.attr('title', imgset['alt_text']);
                } else {
                    if (typeof imgset['caption_title'] !== 'undefined' || imgset['caption_title'] !== '') {
                        img_cont.attr('title', imgset['caption_title']);
                    }
                }
                // appending no script
                slider.append($('<noscript>').append(img));
                img_cont.css('background-image', 'url(' + urls[current_breakpoint] + ')');
                // appending img
                slider.append(img_cont);
                // appending captions if set
                var class_wrapper = 'hide';
                if ((typeof imgset['caption_title'] !== 'undefined' && imgset['caption_title'] !== '') || (typeof imgset['caption_subtitle'] !== 'undefined' && imgset['caption_subtitle'] !== '')) {
                    var class_wrapper = 'show';
                    var caption_title = (typeof imgset['caption_title'] !== 'undefined' && imgset['caption_title'] !== '') ? '<div class="caption_title main_title">' + imgset['caption_title'] + '</div>' : '';
                    var caption_subtitle = (typeof imgset['caption_subtitle'] !== 'undefined' && imgset['caption_subtitle'] !== '') ? '<div class="caption_subtitle main_subtitle">' + imgset['caption_subtitle'] + '</div>' : '';
                    // gallery button on hotel page
                    if (typeof gallery_button_on_ss !== 'undefined' && gallery_button_on_ss === true) {
                        gallery_button = '<a class="button open_gallery hidden-xs hidden-sm" href="javascript:void(0)">' + gallery_button_label + '</a>';
                    }
                }
                // appending images to sshow
                var caption_content = jQuery('<div class="caption_content" />').append(caption_title).append(caption_subtitle);
                var caption_wrapper = jQuery('<div class="caption_wrap ' + class_wrapper + '" />').append(caption_content);
                var caption = jQuery('<div class="caption_box" />').append(caption_wrapper).append(gallery_button);
                if (!$('body').hasClass('homepage')) caption.addClass('hidden-xs'); // furrrrrrbo
                if ($('body').hasClass('error404')) caption.removeClass('hidden-xs');
                slider.append(caption);
            }
            sshow.append(slider);
        });
        // resize ss box
        //slideshowHeight();
        //  sshowwww
        if (sshow_image_data.length === 1) {
            loading.fadeOut(2000);
            // $(window).unbind("mouseenter");
        } else {
            // append arrows
            $('<a href="javascript:;" class="arrow prev"></a>').insertAfter(sshow);
            $('<a href="javascript:;" class="arrow next"></a>').insertAfter(sshow);
            $('<span class="pager"></span>').insertAfter(sshow);
            $('<span class="buttons"><a href="javascript:;" class="fa fa-play"></a><a href="javascript:;" class="fa fa-stop"></a></span>').insertAfter(sshow);
            if (!sshow.hasClass('slick-initialized')) {
                // On init event
                sshow.on('init', function (event, slick, direction) {
                    loading.fadeOut(500);
                    // $(window).unbind("mouseenter");
                });
                if (jQuery('html').hasClass('special_offers')) {
                    if (is_mobile) {
                        sshow.slick({
                            accessibility: true,
                            arrows: true,
                            dots: true,
                            appendDots: sshow.parent().find('.pager'),
                            autoplay: false,
                            autoplaySpeed: ss_timeout,
                            speed: ss_speed,
                            fade: true,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            prevArrow: sshow.parent().find('.arrow.prev'),
                            nextArrow: sshow.parent().find('.arrow.next'),
                            infinite: true,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        arrows: false
                                    }
                                }
                            ]
                        });
                    } else {
                        sshow.slick({
                            accessibility: true,
                            arrows: true,
                            dots: true,
                            appendDots: sshow.parent().find('.pager'),
                            autoplay: false,
                            autoplaySpeed: ss_timeout,
                            speed: ss_speed,
                            fade: true,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            prevArrow: sshow.parent().find('.arrow.prev'),
                            nextArrow: sshow.parent().find('.arrow.next'),
                            infinite: true,
                            customPaging: function (slider, i) {
                                var title_theme = $(slider.$slides[i]).data('title');
                                return '<a href="javascript:;"> ' + title_theme + ' </a>';
                            },
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        arrows: false
                                    }
                                }
                            ]
                        });
                    }
                } else {
                    sshow.slick({
                        accessibility: true,
                        arrows: true,
                        dots: true,
                        appendDots: sshow.parent().find('.pager'),
                        autoplay: false,
                        autoplaySpeed: ss_timeout,
                        speed: ss_speed,
                        fade: true,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        prevArrow: sshow.parent().find('.arrow.prev'),
                        nextArrow: sshow.parent().find('.arrow.next'),
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ]
                    });
                }
                sshow.on('beforeChange', function (event, slick, currentSlide, direction) {
                    jQuery(slick.$slides[currentSlide]).removeClass('animate');
                    jQuery(slick.$slides[direction]).addClass('animate');
                });
                // buttons
                var btn_stop = jQuery('#slideshow_wrapper .fa-stop');
                var btn_play = jQuery('#slideshow_wrapper .fa-play');
                // slickPause
                btn_stop.on('click', function () {
                    sshow.slick('slickPause');
                    btn_play.removeClass('active');
                    $(this).addClass('active');
                });
                // slickPlay
                btn_play.on('click', function () {
                    sshow.slick('slickPlay');
                    btn_stop.removeClass('active');
                    $(this).addClass('active');
                });
            }
        }
        // });
    };

    // box filters
    window.box_filters_manage = window.box_filters_manage || function () {
        // vars
        var box_wrap = jQuery('#box_filters');
        var href;
        // check
        if (box_wrap.length === 0) return false;
        // horrific manouver
        if (window.is_mobile) {
            box_wrap.find('.active').removeClass('active');
        } else {
            // menu
            if (box_wrap.find('.sel_tab.active').length === 0) {
                box_wrap.find('.sel_tab').eq(0).addClass('active');
            }
            // tabs
            if (box_wrap.find('.box_tab.active').length === 0) {
                box_wrap.find('.box_tab').eq(0).addClass('active');
            }
        }
        // close
        box_wrap.find('.close_box').on('click', function () {
            box_wrap.find('.active').removeClass('active');
        });
        // filters go
        // destinations
        box_wrap.find('.submit_destination').on('click', function () {
            // take the url
            href = box_wrap.find('.box_tab.active select[name=hotel_destinations]').val();
            // go to destination page
            window.location.href = href;
        });
        // experiences
        box_wrap.find('.submit_experience').on('click', function () {
            // take the base url
            href = $(this).data('href');
            // params array
            var params = {};
            // take the selected option slug
            var destination = box_wrap.find('.box_tab.active select[name=hotel_destinations] option:selected').data('term_slug');
            if (typeof destination !== 'undefined' && destination !== '') params['destination'] = destination;
            // take the theme
            var theme = box_wrap.find('.box_tab.active select[name=hotel_theme] option:selected').val();
            if (typeof theme !== 'undefined' && theme !== '') params['theme'] = theme;
            // make url
            var url = (!jQuery.isEmptyObject(params)) ? href + '?' + jQuery.param(params) : href;
            // go to destination page
            window.location.href = url;
        });
    };

    // scroll divs
    window.custom_scroll = window.custom_scroll || function () {
        //
        var scroll_x = jQuery('.horizontal_scroll');
        var menu_container_wrapper = jQuery('.menu_box').width();
        var children = jQuery('.menu_box').children();
        var totalWidth = 0;
        children.each(function () {
            totalWidth += $(this).outerWidth();
            // change to .outerWidth(true) if you want to calculate margin too.
        });
        if (totalWidth > menu_container_wrapper) {
            if (scroll_x.length > 0) {
                scroll_x.mCustomScrollbar({
                    axis: "x" // horizontal scrollbar
                });
            }
        }
        //
        var scroll_y = jQuery('.vertical_scroll');
        if (scroll_y.length > 0) {
            scroll_y.mCustomScrollbar({
                axis: "y" // horizontal scrollbar
            });
        }
    };

    /////// END GENERAL FUNCTIONS

    //////// THEME FUNCTIONS //////////

    // open the mobile menu
    window.mobile_menu_open = window.mobile_menu_open || function () {
        var btn = jQuery('.open_mobile_menu');
        var sidebar = jQuery('#sidebar');
        if (btn.length === 0 || sidebar.length === 0) return;
        // var sidebar_overlay = jQuery('#sidebar_overlay');
        var mClass = ('visible');
        var htmlClass = ('noscroll');
        var html = jQuery('html');
        // open
        btn.on('click tap', function () {
            if (!sidebar.hasClass(mClass)) {
                sidebar.addClass(mClass);
                jQuery(this).addClass(mClass);
                html.addClass(htmlClass);
            } else {
                sidebar.removeClass(mClass);
                jQuery(this).removeClass(mClass);
                html.removeClass(htmlClass);
            }
        });
        // close
        jQuery('.close_sidebar').on('click tap', function () {
            if (sidebar.hasClass(mClass)) {
                sidebar.removeClass(mClass);
                jQuery(this).removeClass(mClass);
                html.removeClass(htmlClass);
                if ($(window).width() < 350) {
                    sidebar.css('left', -$(window).width());
                }
            }
        });
        // open
        jQuery('.menu_box .more_li').on('click', function () {
            console.log('click');
            var sub_menu = $(this).next();
            console.log(sub_menu);
            if (sub_menu.hasClass('visible')) {
                sub_menu.removeClass('visible');
                sub_menu.removeClass('visible')
            } else {
                sub_menu.addClass('visible');
            }
        });
    };

    // large_carousel
    window.large_carousel = window.large_carousel || function () {
        // objs
        var carousel_box = $('.large_carousel');
        // check
        if (carousel_box.length === 0) return false;
        // go
        carousel_box.each(function () {
            // target
            var gallery = $(this);
            var carousel_nav = gallery.closest('.section').find('.large_carousel_nav');
            // check if is already slicked
            if (gallery.hasClass('slick-initialized')) {
                return false;
            }
            //
            var slickSettings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                centerMode: false,
                dots: true,
                appendDots: gallery.closest('.large_carousel_wrapper').find('.pager'),
                autoplay: false,
                prevArrow: gallery.closest('.large_carousel_wrapper').find('.arrow.prev'),
                nextArrow: gallery.closest('.large_carousel_wrapper').find('.arrow.next'),
                infinite: true,
                variableWidth: false
            };
            // debug(slickSettings);
            gallery.slick(slickSettings);
            //
            if (carousel_nav.length > 0) {
                carousel_nav.find('.nav a').on('click', function () {
                    var id = $(this).data('index');
                    var slide = carousel_box.find('#' + id);
                    // console.log(slide.data('slick-index'));
                    gallery.slick('slickGoTo', slide.data('slick-index'));
                    carousel_nav.find('.nav a.active').removeClass('active');
                    $(this).addClass('active');
                });
            }
        });
    };

    // simple carousel
    window.simple_carousel = window.simple_carousel || function (obj) {
        // objs
        var carousel_box = (typeof obj === 'undefined') ? $('.carousel_images') : obj;
        // check
        if (carousel_box.length === 0) return false;
        // go
        carousel_box.each(function () {
            // target
            var gallery = $(this);
            // check
            if (gallery.hasClass('slick-initialized')) return false;
            // settings
            var slickSettings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                centerMode: false,
                dots: false,
                autoplay: false,
                prevArrow: gallery.closest('.thumb_box').find('.arrow.prev'),
                nextArrow: gallery.closest('.thumb_box').find('.arrow.next'),
                infinite: true,
                variableWidth: false
            };
            // debug(slickSettings);
            gallery.slick(slickSettings);
        });
    };

    // carousel only on mobile
    window.mobile_carousel = window.mobile_carousel || function () {
        //
        var mobile_carousel = jQuery('.mobile_carousel');
        // check
        if (mobile_carousel.length === 0) return false;
        //
        $(window).on('load resize', function () {
            // go
            mobile_carousel.each(function () {
                // target
                var gallery = $(this);
                // check
                // settings
                var slickSettings = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    centerMode: false,
                    dots: true,
                    appendDots: gallery.parent().find('.pager'),
                    autoplay: false,
                    prevArrow: gallery.parent().find('.arrow.prev'),
                    nextArrow: gallery.parent().find('.arrow.next'),
                    infinite: true,
                    variableWidth: false,
                    mobileFirst: true
                };
                // check mobile
                if (!window.is_mobile) {
                    if (gallery.hasClass('slick-initialized')) {
                        gallery.slick('unslick');
                    }
                    return;
                }
                if (!gallery.hasClass('slick-initialized')) {
                    // debug(slickSettings);
                    gallery.slick(slickSettings);
                }
            });
        });
    };

    // slick tabs
    window.slick_tabs = window.slick_tabs || function () {
        // vars
        var slick_tabs = jQuery('.slick_tabs');
        // check
        if (slick_tabs.length === 0) return false;
        // vars
        var slick_tabs_menu = slick_tabs.find('.tabs_menu');
        var slick_tabs_tabs = slick_tabs.find('.tabs_box');

        if (!slick_tabs_tabs.hasClass('slick-initialized')) {
            //
            slick_tabs_tabs.slick({
                arrows: true,
                dots: false,
                autoplay: false,
                fade: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                prevArrow: slick_tabs_tabs.parent().find('.arrow.prev'),
                nextArrow: slick_tabs_tabs.parent().find('.arrow.next'),
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
            // click  on arrows or pager
            slick_tabs_tabs.on('afterChange', function (event, slick, currentSlide, direction) {
                // the index is currentSlide
                slick_tabs_menu.find('.sel_tab.active').removeClass('active');
                slick_tabs_menu.find('.sel_tab#tab_' + currentSlide).addClass('active');
            });

            // click menu tab
            slick_tabs_menu.on('click', '.sel_tab', function (event) {
                // vars
                var btn = $(this);
                // reset btns
                slick_tabs_menu.find('.sel_tab.active').removeClass('active');
                // make it active
                btn.addClass('active');
                // go slick
                slick_tabs_tabs.slick('slickGoTo', $(this).data('slick-index'));
            });
        }
    };

    // hotel journeys

    //hotel minigallery section
    window.minigallery_hotel = window.minigallery_hotel || function () {
        // vars
        var minigallery_wrapper = jQuery('.minigallery_thumbnails');
        if (minigallery_wrapper.length > 0) {
            minigallery_wrapper.on('init', function () {
                lazyLoadInstance.update();
            });
            minigallery_wrapper.not('.slick-initialized').slick({
                slidesToShow: 3,
                arrows: true,
                prevArrow: minigallery_wrapper.parent().find('.arrow.prev'),
                nextArrow: minigallery_wrapper.parent().find('.arrow.next'),
            });
        }
        var single_slide = minigallery_wrapper.find('.slide');
        single_slide.on('click', function () {
            // vars
            var gallery_wrap = jQuery('.hotel_gallery_wrapper');
            // vars
            var gallery = jQuery('.hotel_gallery_box .gallery');
            var gallery_thumbs = jQuery('.hotel_gallery_box .gallery_thumbnails');
            // checks
            if (typeof gallery === 'undefined' || gallery.length === 0) return false;
            if (typeof (gallery_image_data) === 'undefined' || gallery_image_data.length === 0) return false;
            // check if already init
            if (gallery.hasClass('slick-initialized')) {
                gallery_wrap.addClass('overlayed');
                gallery_wrap.addClass('visible');
                return;
            }
            // calculating size
            var current_breakpoint = window.create_breakpoint();

            // create and append gallery
            $.each(gallery_image_data, function (index, imgset) {
                // images set
                var urls = imgset['url_set'];
                // do the other images
                var id = imgset['ID'];
                var img = jQuery('<img />').attr('src', imgset['url_set'][current_breakpoint]).attr('alt', imgset['title']);
                var anchor = jQuery('<a class="fancy_gallery" />').attr('href', imgset['url_set']['max']).attr('alt', imgset['title']);
                var slider = jQuery('<div class="slide" data-id="' + id + '" />');
                var img_cont = jQuery('<div class="slide_image">');
                // appending anchor
                img_cont.append(anchor);
                // appending no script
                slider.append($('<noscript>').append(img));
                img_cont.css('background-image', 'url(' + urls[current_breakpoint] + ')');
                // appending img
                slider.append(img_cont);
                // appending captions if set
                if (typeof imgset['caption_title'] !== 'undefined' || imgset['caption_title'] !== '' || typeof imgset['caption_subtitle'] !== 'undefined' || imgset['caption_subtitle'] !== '') {
                    var caption_title = (typeof imgset['caption_title'] !== 'undefined' && imgset['caption_title'] !== '') ? '<div class="caption_title main_title">' + imgset['caption_title'] + '</div>' : '';
                    // var caption_subtitle = (typeof imgset['caption_subtitle'] !== 'undefined' && imgset['caption_subtitle'] !== '') ? '<div class="caption_subtitle main_subtitle">' + imgset['caption_subtitle'] + '</div>' : ''; .append(caption_subtitle)
                    var caption_content = jQuery('<div class="caption_content" />').append(caption_title);
                    var caption = jQuery('<div class="caption_box" />').append(caption_content);
                    slider.append(caption);
                }
                // appending images to gallery wrap
                gallery.append(slider);
                // thumbnails
                var thumb_img = jQuery('<img />').attr('src', imgset['url_set'][current_breakpoint]).attr('alt', imgset['title']);
                var thumb_anchor = jQuery('<a class="slick_slide_to" />').attr('href', 'javascript:void(0)').attr('alt', imgset['title']);
                var thumb_slider = jQuery('<div class="slide" data-id="' + id + '" />');
                var thumb_img_cont = jQuery('<div class="slide_image">');
                // appending anchor
                thumb_img_cont.append(thumb_anchor);
                // appending no script
                thumb_slider.append($('<noscript>').append(thumb_img));
                thumb_img_cont.css('background-image', 'url(' + urls[current_breakpoint] + ')');
                // appending img
                thumb_slider.append(thumb_img_cont);
                // appending images to gallery thumb
                gallery_thumbs.append(thumb_slider);
            });

            //  sshowwww
            if (gallery_image_data.length === 1) {
                // loading.fadeOut(2000);
            } else {
                if (!gallery.hasClass('slick-initialized')) {
                    jQuery('html').addClass('noscroll');
                    gallery_wrap.addClass('overlayed');
                    gallery_wrap.addClass('visible');
                    //
                    gallery.slick({
                        arrows: true,
                        dots: false,
                        autoplay: false,
                        fade: true,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        prevArrow: '<span class="arrow prev">&nbsp;</span>',
                        nextArrow: '<span class="arrow next">&nbsp;</span>',
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ],
                        asNavFor: '.hotel_gallery_box .gallery_thumbnails'
                    });
                    // nav
                    var sts = 7;
                    gallery_thumbs.slick({
                        arrows: false,
                        dots: false,
                        autoplay: false,
                        fade: false,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        slidesToShow: sts,
                        slidesToScroll: 1,
                        infinite: true,
                        focusOnSelect: true,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 5
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3
                                }
                            }
                        ],
                        asNavFor: '.hotel_gallery_box .gallery'
                    });
                    // click on nav
                    // On init event
                    gallery_thumbs.on('click', '.slide', function (event) {
                        gallery.slick('slickGoTo', $(this).data('slick-index'));
                    });

                    gallery.on({
                        afterChange: function (event, slick, current_slide_index) {
                            gallery_thumbs.find('.slick-slide').removeClass('slick-current');
                            gallery_thumbs.find('.slick-slide[data-slick-index="' + current_slide_index + '"]').addClass('slick-current');
                        }
                    });
                }
            }


            //bind fancy box
            jQuery('.fancy_gallery').fancybox({
                fullScreen: {
                    autoStart: true,
                    'closeOnExit': true
                },
                buttons: [
                    // "zoom",
                    //"share",
                    // "slideShow",
                    // "fullScreen",
                    //"download",
                    // "thumbs",
                    "close"
                ],
                autoSize: false,
                scrolling: false

            });
            // close gallery
            jQuery(document).on('click', '.close_gallery', function () {
                gallery_wrap.removeClass('overlayed');
                gallery_wrap.removeClass('visible');
                jQuery('html').removeClass('noscroll');
            });
        });
        //Slide to when is open
        single_slide.on('click', function () {
            jQuery('.hotel_gallery_box .gallery').slick('slickGoTo', $(this).data('slick-index'));
            jQuery('.hotel_gallery_box .gallery_thumbnails').slick('slickGoTo', $(this).data('slick-index'));
        });
    };
    // hotel gallery
    window.gallery_hotel = window.gallery_hotel || function () {
        // vars
        var gallery_btn = jQuery('.open_gallery');
        var gallery_wrap = jQuery('.hotel_gallery_wrapper');
        // check
        if (gallery_btn.length === 0) return false;
        // go
        jQuery(document).on('click', '.open_gallery', function () {
            // vars
            var gallery = jQuery('.hotel_gallery_box .gallery');
            var gallery_thumbs = jQuery('.hotel_gallery_box .gallery_thumbnails');
            // checks
            if (typeof gallery === 'undefined' || gallery.length === 0) return false;
            if (typeof (gallery_image_data) === 'undefined' || gallery_image_data.length === 0) return false;
            // check if already init
            if (gallery.hasClass('slick-initialized')) {
                gallery_wrap.addClass('overlayed');
                gallery_wrap.addClass('visible');
                return;
            }
            // calculating size
            var current_breakpoint = window.create_breakpoint();
            // create and append gallery
            $.each(gallery_image_data, function (index, imgset) {
                // images set
                var urls = imgset['url_set'];
                // do the other images
                var id = imgset['ID'];
                var img = jQuery('<img />').attr('src', imgset['url_set'][current_breakpoint]).attr('alt', imgset['title']);
                var anchor = jQuery('<a class="fancy_gallery" />').attr('href', imgset['url_set']['max']).attr('alt', imgset['title']);
                var slider = jQuery('<div class="slide" data-id="' + id + '" />');
                var img_cont = jQuery('<div class="slide_image">');
                // appending anchor
                img_cont.append(anchor);
                // appending no script
                slider.append($('<noscript>').append(img));
                img_cont.css('background-image', 'url(' + urls[current_breakpoint] + ')');
                // appending img
                slider.append(img_cont);
                // appending captions if set
                if (typeof imgset['caption_title'] !== 'undefined' || imgset['caption_title'] !== '' || typeof imgset['caption_subtitle'] !== 'undefined' || imgset['caption_subtitle'] !== '') {
                    var caption_title = (typeof imgset['caption_title'] !== 'undefined' && imgset['caption_title'] !== '') ? '<div class="caption_title main_title">' + imgset['caption_title'] + '</div>' : '';
                    // var caption_subtitle = (typeof imgset['caption_subtitle'] !== 'undefined' && imgset['caption_subtitle'] !== '') ? '<div class="caption_subtitle main_subtitle">' + imgset['caption_subtitle'] + '</div>' : ''; .append(caption_subtitle)
                    var caption_content = jQuery('<div class="caption_content" />').append(caption_title);
                    var caption = jQuery('<div class="caption_box" />').append(caption_content);
                    slider.append(caption);
                }
                // appending images to gallery wrap
                gallery.append(slider);
                // thumbnails
                var thumb_img = jQuery('<img />').attr('src', imgset['url_set'][current_breakpoint]).attr('alt', imgset['title']);
                var thumb_anchor = jQuery('<a class="slick_slide_to" />').attr('href', 'javascript:void(0)').attr('alt', imgset['title']);
                var thumb_slider = jQuery('<div class="slide" data-id="' + id + '" />');
                var thumb_img_cont = jQuery('<div class="slide_image">');
                // appending anchor
                thumb_img_cont.append(thumb_anchor);
                // appending no script
                thumb_slider.append($('<noscript>').append(thumb_img));
                thumb_img_cont.css('background-image', 'url(' + urls[current_breakpoint] + ')');
                // appending img
                thumb_slider.append(thumb_img_cont);
                // appending images to gallery thumb
                gallery_thumbs.append(thumb_slider);
            });

            //  sshowwww
            if (gallery_image_data.length === 1) {
                // loading.fadeOut(2000);
            } else {
                if (!gallery.hasClass('slick-initialized')) {
                    jQuery('html').addClass('noscroll');
                    gallery_wrap.addClass('overlayed');
                    gallery_wrap.addClass('visible');
                    //
                    gallery.slick({
                        arrows: true,
                        dots: false,
                        autoplay: false,
                        fade: true,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        prevArrow: gallery.parent().find('.arrow.prev'),
                        nextArrow: gallery.parent().find('.arrow.next'),
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ],
                        asNavFor: '.hotel_gallery_box .gallery_thumbnails'
                    });
                    // nav
                    var sts = 7;
                    gallery_thumbs.slick({
                        arrows: false,
                        dots: false,
                        autoplay: false,
                        fade: false,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        slidesToShow: sts,
                        slidesToScroll: 1,
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 5
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3
                                }
                            }
                        ],
                        asNavFor: '.hotel_gallery_box .gallery'
                    });
                    // click on nav
                    // On init event
                    gallery_thumbs.on('click', '.slide', function (event) {
                        gallery.slick('slickGoTo', $(this).data('slick-index'));
                    });

                }
            }
            // bind fancy box
            jQuery('.fancy_gallery').fancybox({
                fullScreen: {
                    autoStart: true,
                    'closeOnExit': true
                },
                buttons: [
                    // "zoom",
                    //"share",
                    // "slideShow",
                    // "fullScreen",
                    //"download",
                    // "thumbs",
                    "close"
                ],
                autoSize: false,
                scrolling: false

            });
        });
        // close gallery
        jQuery(document).on('click', '.close_gallery', function () {
            gallery_wrap.removeClass('overlayed');
            gallery_wrap.removeClass('visible');
            jQuery('html').removeClass('noscroll');
        });
    };

    // rooms fancy
    window.popup_carousel = window.popup_carousel || function (instance, current) {
        var detail_carousel = current.$content.find('.carousel_images');
        if (detail_carousel.length > 0) simple_carousel(detail_carousel);
    };

    // rooms carousel
    window.popup_fancy = window.popup_fancy || function () {
        // vars
        var btns = jQuery('.popup_fancy');
        // check
        if (btns.length === 0) return false;
        // click fancy
        btns.each(function () {
            // this
            var btn = $(this);
            // bind fancy
            btn.fancybox({
                afterShow: function (instance, current) {
                    popup_carousel(instance, current);
                    var type = '';
                    if (btn.attr('href').match(/restaurant_/)) {
                        type = 'restaurant';
                    }
                    if (btn.attr('href').match(/room_/)) {
                        type = 'room';
                    }

                    btn.trigger('mantis.hotel_section_details_' + type);
                },
                afterClose: function (instance, current) {
                    var detail_carousel = current.$content.find('.carousel_images');
                    if (detail_carousel.hasClass('slick-initialized')) {
                        detail_carousel.slick('unslick');
                    }
                }
            });
        });
    };

    // function for google map
    window.google_map = window.google_map || function () {
        // starting up map template-part
        var map_id = 'map_canvas';
        if ((jQuery('#' + map_id).length > 0)) {
            // go map
            initializeMap(map_id, gmap_config);

        }
    };

    // posts carousel
    window.other_posts = window.other_posts || function () {
        // objs
        var carousel_box = $('.other_posts_box');
        // check
        if (carousel_box.length === 0) return false;
        // go
        carousel_box.each(function () {
            // target
            var gallery = $(this);
            // check
            if (gallery.hasClass('slick-initialized')) return false;

            // check sts
            var avail_w = parseInt(gallery.width() * 0.825, 10);
            var actual_slides = (is_mobile) ? avail_w : '250';
            var sts = Math.floor(avail_w / actual_slides);
            // settings
            var slickSettings = {
                slidesToShow: sts,
                slidesToScroll: 1,
                arrows: true,
                centerMode: false,
                dots: false,
                autoplay: false,
                prevArrow: gallery.parent().find('.arrow.prev'),
                nextArrow: gallery.parent().find('.arrow.next'),
                infinite: true,
                variableWidth: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        appendDots: gallery.parent().find('.pager')
                    }
                }]
            };
            gallery.slick(slickSettings);

            var count = gallery.slick("getSlick").slideCount;
            // console.log(count);

            if (is_phone) {
                if (count < 2) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            } else if (jQuery(window).width() >= 768 && jQuery(window).width() <= 1440) {
                if (count < 3) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            } else {
                if (count < 4) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            }
        });
    };

    //NEWWWW
    // posts carousel
    window.other_offers = window.other_offers || function () {
        // objs
        var carousel_box = $('.other_offers_box, .other_hotels_box ');
        // check
        if (carousel_box.length === 0) return false;
        // go
        carousel_box.each(function () {
            // target
            var gallery = $(this);
            // check
            if (gallery.hasClass('slick-initialized')) return false;

            // check sts
            var avail_w = parseInt(gallery.width() * 0.825, 10);
            var actual_slides = (is_mobile) ? avail_w : '250';
            var sts = Math.floor(avail_w / actual_slides);

            //check if is single hotel or offer CPT
            if ($('html').hasClass('single-hotel')) {
                var prev_btn = previous_hotel;
                var next_btn = next_hotel;
            } else if ($('html').hasClass('single-offer')) {
                var prev_btn = previous_item;
                var next_btn = next_item;
            }
            //Check my total items are more than 2
            if (gallery.find('.box').length > 2) {
                var show_arrow = true;
            } else {
                var show_arrow = false;
            }

            window.number_slide;

            if (is_phone) {
                number_slide = 1;
            } else if (jQuery(window).width() >= 768 && jQuery(window).width() <= 1440) {
                number_slide = 3;
            } else {
                number_slide = 4;
            }

            // settings
            var slickSettings = {
                slidesToShow: number_slide,
                slidesToScroll: 1,
                arrows: show_arrow,
                centerMode: false,
                dots: false,
                autoplay: false,
                prevArrow: '<a class="arrow prev" href="javascript:;" aria-label="' + prev_btn + '">&nbsp;</a>',
                nextArrow: '<a class="arrow next" href="javascript:;" aria-label="' + next_btn + '">&nbsp;</a>',
                infinite: true,
                variableWidth: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        appendDots: gallery.parent().find('.pager')
                    }
                }]
            };

            gallery.on('init', function (event, slick) {
                lazyLoadInstance.update();
            });

            gallery.slick(slickSettings);

            var count = gallery.slick("getSlick").slideCount;
            // console.log(count);

            if (is_phone) {
                if (count < 2) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            } else if (jQuery(window).width() >= 768 && jQuery(window).width() <= 1440) {
                if (count < 3) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            } else {
                if (count < 4) {
                    gallery.find('.slick-track').addClass('slick-no-slide');
                    gallery.find('.slick-list').addClass('slick-no-slide');
                } else {
                    gallery.find('.slick-track').removeClass('slick-no-slide');
                    gallery.find('.slick-list').removeClass('slick-no-slide');
                }
            }
        });
    };

    /////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////

    //
    window.hotels_filters_counters = window.hotels_filters_counters || function (init) {
        // vars
        var box_filters = jQuery('.hotel_box_filters');
        var box_hotels = jQuery('.hotel_box_list');
        // checks
        if (box_filters.length === 0 || box_hotels.length === 0) return false;
        // inputs
        var inputs = box_filters.find('input');
        var hotels_count;
        var hotels_count_wrap = jQuery('.hotel_counter');
        // cats counter
        var cats_counter = [];
        var cats_counter_wrap = jQuery('.cats_counter');
        // counters - initialize
        // hotels
        if (typeof init === 'undefined') {
            // on load page
            hotels_count = box_hotels.find('.hotel_box').length;
            hotels_count_wrap.html(hotels_count).addClass('visible');
        } else {
            // not load page
            // triggered with filters
            hotels_count = box_hotels.find('.hotel_box.filtered').length;
            hotels_count_wrap.html(hotels_count);
        }

        // input loop
        inputs.each(function () {
            // filter box
            var filter_box = $(this).closest('.single_filter');
            // with the name (filter)
            var name = $(this).attr('name');
            // if is the init
            if (typeof init === 'undefined') {
                // on load page
                // i check the box with that filter
                var cat_hotels = box_hotels.find('.' + name).length;
                // let's get the counter container
                var cat_cont = filter_box.find('.cat_counter');
                // if i found hotels
                if (cat_hotels > 0) {
                    cat_cont.html(cat_hotels).addClass('visible');
                } else {
                    $(this).prop('disabled', 'disabled');
                    filter_box.addClass('disabled');
                }
            } else {
                // triggered with filters
                // console.log('// triggered with filters ');
            }
            // if is checked
            if ($(this).prop('checked') === true) {
                var label = $("label[for='" + $(this).attr('name') + "']");
                if (label.length > 0) {
                    cats_counter.push(label.text());
                }
            }
            // check and go
            if (cats_counter.length > 0) {
                var cats_list = cats_counter.join(', ');
                cats_counter_wrap.html(cats_list);
            } else {
                cats_counter_wrap.html('');
            }
        });
        // load more checker
        if (cats_counter.length === 0) {
            jQuery('.load_more').show();
        } else {
            jQuery('.load_more').hide();
        }

    };
    // filters parser
    window.hotels_filters_parser = window.hotels_filters_parser || function (div) {
        // checks
        if (div.length === 0) return false;
        // initialize
        var values = [];
        // inputs
        div.find('input').each(function () {
            if ($(this).prop("checked") === true) {
                values.push($(this).attr('name'));
            }
        });
        return values;
    };

    // filter action
    window.hotels_filters = window.hotels_filters || function () {
        // vars
        var box_filters = jQuery('.hotel_box_filters');
        var box_hotels = jQuery('.hotel_box_list');
        // checks
        if (box_filters.length === 0 || box_hotels.length === 0) return false;
        // inputs
        var inputs = box_filters.find('input');
        // each click on inputs
        inputs.each(function () {
            $(this).on('change', function () {
                // search the checked checkboxes
                var values = hotels_filters_parser(box_filters);
                // box hotels
                var hotel_boxes = box_hotels.find('.hotel_box');
                // if i found values
                if (values.length > 0) {
                    hotel_boxes.each(function () {
                        var show = false;
                        var hotel_cat_json = $(this).data('hotel_cats'); // it's an array !?!?!?!?!
                        // cycle the values
                        $.each(values, function (i, item) {
                            // i starts from 0
                            // item is the filter selected
                            // check is in array
                            if ($.inArray(item, hotel_cat_json) !== -1) { // WORST FUNCTION EVER
                                show = true;
                            }
                        });
                        // do stuff
                        if (show) {
                            $(this).removeClass('not_visible').addClass('filtered');
                        } else {
                            $(this).removeClass('filtered').addClass('not_visible');
                        }
                    });
                    // redo counters with filters
                    hotels_filters_counters(false);
                } else {
                    // reset button
                    hotel_boxes.each(function (i) {
                        // reset filter class
                        $(this).removeClass('filtered');
                        if (i < 5) {
                            $(this).removeClass('not_visible');
                        } else {
                            $(this).addClass('not_visible');
                        }
                    });
                    // redo counters without filters
                    hotels_filters_counters();
                }
                // ALL part
                if ($(this).attr('name') === 'filter_all' || $(this).attr('name') === 'filter_all_exps') {
                    var others = $(this).closest('.filters').find('.single_filter input');
                    others.each(function () {
                        if ($(this).attr('name') !== 'filter_all' && $(this).attr('name') !== 'filter_all_exps') {
                            $(this).prop('checked', false);
                        }
                    });
                } else {
                    box_filters.find('input[name=filter_all],input[name=filter_all_exps]').prop('checked', false);
                }
                // scroll tooooo
                var offset = parseInt(jQuery('.hotels_list .titles_container ').outerHeight(true) + 10, 10);
                scroll_to('#hotel_list', offset);
            });
        });

        // load more  button
        jQuery('.load_more').on('click', function () {
            // box hotels
            var hotel_boxes = box_hotels.find('.hotel_box.not_visible');
            // take first five if i have more than 5 hotels
            if (hotel_boxes.length > 5) {
                hotel_boxes = hotel_boxes.slice(0, 5);
            } else {
                // hide the button!
                $(this).hide();
            }
            // reset button
            hotel_boxes.each(function () {
                //
                $(this).removeClass('not_visible');
            });
        });

        // mobile part
        simple_open_close('.mobile_hotel_box_filters a');
        simple_open_close('.filters_wrap_open  a');

        // reset button
        jQuery('.clear_filters').on('click', function () {
            // box hotels
            var hotel_boxes = box_hotels.find('.hotel_box');
            // inputs
            var inputs = box_filters.find('input');
            // each click on inputs
            inputs.each(function () {
                $(this).prop('checked', false);
            });
            // reset button
            hotel_boxes.each(function () {
                //
                $(this).removeClass('not_visible').removeClass('filtered');
            });
            // redo counters without filters
            hotels_filters_counters();
        });
        // fixed box filters
        jQuery(window).on('scroll', function () {
            // checkpoint for top -> scroll + header h - distance from top margin of filter box to top page margin
            var checkpoint_top = parseInt(jQuery(window).scrollTop() + jQuery('#header').outerHeight() - box_filters.offset().top, 10);
            if (checkpoint_top > 0 && !window.is_mobile) {
                box_filters.addClass('fixed');
            } else {
                box_filters.removeClass('fixed');
            }
            // checkpoint for bottom
            var filters_box = jQuery('#mobile_box_filters');
            var hotels_list = jQuery('#hotels_list');
            var experience_hotels = jQuery('#experience_hotels');
            var checkpoint_bottom;
            // border bottom of the fixed box
            var bottom_pos = parseInt(jQuery(window).scrollTop() + filters_box.outerHeight() + jQuery('#header').outerHeight(), 10);
            // limit of the whole hotel box
            if (hotels_list.length > 0) {
                checkpoint_bottom = parseInt(hotels_list.offset().top + hotels_list.outerHeight(), 10);
            }
            if (experience_hotels.length > 0) {
                checkpoint_bottom = parseInt(experience_hotels.offset().top + experience_hotels.outerHeight(), 10);
            }
            // checking
            if (bottom_pos > checkpoint_bottom && !window.is_mobile) {
                var m_top = parseInt(checkpoint_bottom - bottom_pos, 10);
                filters_box.css({'margin-top': m_top + 'px'});
            } else {
                filters_box.css({'margin-top': 'auto'});
            }
        });
    };

    // filters action
    window.experiences_filters = window.experiences_filters || function () {
        // vars
        // var box_filters = jQuery('.hotel_box_filters'); box_filters.length === 0 ||
        var experiences_list = jQuery('.experiences_list');
        // checks
        if (experiences_list.length === 0) return false;

        // load more  button
        jQuery('.load_more').on('click', function () {
            // box hotels
            var exps = experiences_list.find('.experience_box.not_visible');
            // take first five if i have more than 5 hotels
            if (exps.length > 5) {
                exps = exps.slice(0, 5);
            } else {
                // hide the button!
                $(this).hide();
            }
            // reset button
            exps.each(function () {
                //
                $(this).removeClass('not_visible');
            });
        });

    };

    // hotel menu scroll
    window.hotel_menu_scroll = window.hotel_menu_scroll || function () {
        // vars
        var hotel_body = jQuery('#body');
        var back_btn = jQuery('#back_to_top');
        // checks
        if (hotel_body.length === 0) return false;
        // calc - h
        if (parseInt(hotel_body.offset().top + hotel_body.outerHeight(true), 10) < parseInt(jQuery(window).scrollTop() + jQuery('#header').outerHeight(), 10)) {
            back_btn.addClass('visible');
        } else {
            back_btn.removeClass('visible');
        }
        //
        back_btn.on('click', function () {
            scroll_to('#hotel_menu');
        });
    };

    // pop up
    window.pop_up = window.pop_up || function () {
        // elems
        var home_pop_up = jQuery("#box_pop_up");
        if (home_pop_up.length === 0) return false;
        setTimeout(function () {
            $.fancybox.open({
                src: '#box_pop_up .box_pop_up',
                type: 'inline',
                opts: {
                    gutter: 0,
                    btnTpl: {
                        smallBtn: '<a data-fancybox-close class="fancy_close" href="javascript:void(0);"><span>&nbsp;</span></a>',
                    }
                }
            });
        }, 500);
    };

    // request quotation special offer button
    window.pop_up = window.pop_up || function () {
        // elems
        var test = jQuery("#trueModal");
        if (test.length === 0) return false;
        setTimeout(function () {
            $.fancybox.open({
                src: '#box_pop_up .box_pop_up',
                afterShow: function () {
                    $('body').trigger('mantis.hotel_offer_quotation', {btn: btn});
                },
                type: 'inline',
                opts: {
                    gutter: 0,
                    btnTpl: {
                        smallBtn: '<a data-fancybox-close class="fancy_close" href="javascript:void(0);"><span>&nbsp;</span></a>',
                    }
                }
            });
        }, 500);
    };

    window.lazy = window.lazy || function () {
        window.lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            threshold: 50
        });
    };

    //
    window.hotel_form_manager = window.hotel_form_manager || function () {
        // vars
        var form = jQuery('#hotel_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.arrival_date');
        var departure_dp = form.find('input.datepicker.departure_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        greacptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.enquire_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.enquire_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // offer form
    window.offer_form_manager = window.offer_form_manager || function () {
        // vars
        var form = jQuery('#offer_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.arrival_date');
        var departure_dp = form.find('input.datepicker.departure_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.offer_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.offer_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };


    // traveller form
    window.traveller_form_manager = window.traveller_form_manager || function () {
        // vars
        var form = jQuery('#traveller_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.arrival_date');
        var departure_dp = form.find('input.datepicker.departure_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date_traveller') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.offer_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.offer_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // agent form
    window.agent_form_manager = window.agent_form_manager || function () {
        // vars
        var form = jQuery('#agent_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.arrival_date');
        var departure_dp = form.find('input.datepicker.departure_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date_agent') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            console.log(formData);
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.offer_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.offer_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // landing page form
    window.landing_page_form_manager = window.landing_page_form_manager || function () {
        // vars
        var form = jQuery('#landing_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.check_in_date');
        var departure_dp = form.find('input.datepicker.check_out_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    // departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            console.log(formData);
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.offer_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.offer_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // general form
    window.general_form_manager = window.general_form_manager || function () {
        // vars
        var form = jQuery('#general_enquiries_form');
        // check
        if (form.length === 0) return false;
        // datepicker
        var arrival_dp = form.find('input.datepicker.arrival_date');
        var departure_dp = form.find('input.datepicker.departure_date');
        var today = new Date();
        var tomorrow = new Date(today.getTime() + 86400000);
        //
        form.find("input.datepicker").datepicker({
            inline: true,
            dateFormat: "dd-mm-yy",
            minDate: new Date(),
            onClose: function (selectedDate, inst) {
                // check
                if (inst.id === 'form_departure_date') return true;
                //
                var new_departure_date;
                //
                if (arrival_dp.length > 0) {
                    var arrival_date = arrival_dp.datepicker('getDate');
                    // if refreshed the page i click on arrival and then on departure without selecting date, i throw an error, to avoid this i have to check arrivaldate
                    if (arrival_date === null) {
                        if (arrival_dp.length > 0) {
                            arrival_dp.datepicker('setDate', today);
                            arrival_date = today;
                        }
                    }
                    new_departure_date = new Date(arrival_date.getTime() + 86400000);
                }
                // checking if the date of the departure is before the new selected arrival date and i put a min date on departure
                if (departure_dp.length > 0) {
                    var departure_date = departure_dp.datepicker('getDate');
                    departure_dp.datepicker('option', 'minDate', new_departure_date);
                    if (departure_date <= arrival_date) {
                        departure_dp.datepicker('setDate', new_departure_date);
                    }
                    departure_dp.datepicker("show");
                }
            }
        });


        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.offer_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.offer_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // contact form
    window.contact_form_manager = window.contact_form_manager || function () {
        // vars
        var form = jQuery('#contact_form');
        // check
        if (form.length === 0) return false;

        // submit form
        form.submit(function (event) {
            event.preventDefault();
            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            //
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                        form.trigger('mantis.contact_form_error');
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                        form.trigger('mantis.contact_form_success');
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };


    window.partner_form_manager = window.partner_form_manager || function () {
        // vars
        var form = jQuery('#partner_form');
        // check
        if (form.length === 0) return false;

        // submit form
        form.submit(function (event) {
            event.preventDefault();

            // disable form
            form.addClass('disabled');
            form.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form.serialize();
            $.ajax({
                type: 'POST',
                url: ajax_obj.ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form.find('.field.alert').removeClass('alert');
                    form.find('.error_holder').html('');
                    if (response.error) {
                        form.find('.error_holder').show().html(response.error_message);
                        setTimeout(function () {
                            form.find('.error_holder').fadeOut('slow', function () {
                                $(this).html('');
                            });
                        }, 6000);
                        grecaptcha.reset();
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            var single_field = form.find('.field.' + error.field);
                            single_field.addClass('alert');
                            single_field.find('.error').text(error.details);
                        }
                        // enable form
                        form.removeClass('disabled');
                        form.find('input[type=submit]').prop('disabled', false);
                    } else {
                        // success print
                        jQuery('.message_box.hide').removeClass('hide');
                        form.fadeOut();
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    };

    // awards_carousel
    window.awards_carousel = window.awards_carousel || function () {
        //
        lazyLoadInstance.update();
        // objs
        var carousel_box = $('.awards_box');
        // check
        if (carousel_box.length === 0) return false;
        // check if is already slicked
        if (carousel_box.hasClass('slick-initialized')) {
            return false;
        }
        // args
        var slickSettings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            centerMode: true,
            dots: false,
            // appendDots: gallery.closest('.large_carousel_wrapper').find('.pager'),
            autoplay: false,
            prevArrow: carousel_box.closest('.awards_wrapper').find('.arrow.prev'),
            nextArrow: carousel_box.closest('.awards_wrapper').find('.arrow.next'),
            infinite: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };
        // debug(slickSettings);
        // go
        carousel_box.slick(slickSettings);
        lazyLoadInstance.update();
    };

    // Special Offers
    window.special_offers = window.special_offers || function () {
        if (jQuery('html').hasClass('special_offers')) {
            var $container = jQuery('.special_offers_wrapper');
            $container.isotope({
                itemSelector: '.single_offer_wrap',
                masonry: {
                    // use element for option
                    columnWidth: '.single_offer_wrap'
                }
            });
            $container.imagesLoaded().progress(function () {
                $container.isotope('layout');

            });

            //****************************
            // Isotope Load more button
            //****************************

            $('#destination').on('change', function () {
                // get filter value from option value
                var filterValue = this.value;
                if (!is_mobile) {
                    if (filterValue != '*') {
                        $container.find('.big_box').addClass('medium-size');
                    } else {
                        $container.find('.big_box').removeClass('medium-size');
                    }
                }

                // use filterFn if matches value
                $container.isotope({filter: filterValue});
            });
        }
    };

    window.carousel_preview_offers = window.carousel_preview_offers || function () {
        if (is_mobile && jQuery('html').hasClass('homepage')) {
            var container = jQuery('.special_offers_wrapper');
            var items = container.find('.single_offer_wrap').length;
            if (items > 1) {
                container.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    appendDots: container.parent().find('.pager'),
                    prevArrow: container.parent().find('.arrow.prev'),
                    nextArrow: container.parent().find('.arrow.next'),
                    infinite: true

                });
            }
        }
    };

    window.hotel_gallery_mobile = window.hotel_gallery_mobile || function () {
        if (is_mobile && $('html').hasClass('single-hotel')) {
            if ($('.open_hotel_gallery').length > 0) {
                $('.open_hotel_gallery').fancybox({
                    buttons: [
                        "close"
                    ]
                });
            }
        }
    }

    //Acessibility function
    var accorAccessibilityStatus = {
        color: 'default',
        fontSize: 'normal',
        letterSpacing: 'normal'
    };
    var accorAccessibilityCookieName = 'accor_accessibility';
    (function () {
        var tmp = Cookies.get(accorAccessibilityCookieName);
        if (tmp) {
            try {
                var obj = JSON.parse(tmp);
                if (typeof obj.color !== 'undefined') {
                    accorAccessibilityStatus.color = obj.color;
                }
                if (typeof obj.fontSize !== 'undefined') {
                    accorAccessibilityStatus.fontSize = obj.fontSize;
                }
                if (typeof obj.letterSpacing !== 'undefined') {
                    accorAccessibilityStatus.letterSpacing = obj.letterSpacing;
                }
            } catch (e) {
            }

        }
    })();

    function saveAccessibilityStatus() {
        var str = JSON.stringify(accorAccessibilityStatus);
        Cookies.set(accorAccessibilityCookieName, str, 1000);
    }

    function applyAccessibilityStatus(reset) {
        reset = reset || false;
        var body = $('body');
        if (accorAccessibilityStatus.color == 'bw') {
            body.addClass('accessibility__BW');
            body.removeClass('accessibility__BY');
            body.removeClass('accessibility__YB');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--white': '#000',
                        '--dark-peach': '#fff',
                        '--charcoal-gray': '#fff',
                        '--submenu-bg': '#000',
                    })
                });
            }, 700);
        }
        if (accorAccessibilityStatus.color == 'by') {
            body.addClass('accessibility__BY');
            body.removeClass('accessibility__BW');
            body.removeClass('accessibility__YB');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--white': '#000',
                        '--dark-peach': '#ff0',
                        '--charcoal-gray': '#ff0',
                        '--submenu-bg': '#000',
                    })
                });
            }, 700);
        }
        if (accorAccessibilityStatus.color == 'yb') {
            body.addClass('accessibility__YB');
            body.removeClass('accessibility__BW');
            body.removeClass('accessibility__BY');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--white': '#ff0',
                        '--dark-peach': '#000',
                        '--charcoal-gray': '#000',
                        '--submenu-bg': '#ff0',
                    })
                });
            }, 700);
        }
        if (accorAccessibilityStatus.fontSize == 'large') {
            body.addClass('larger_font');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--font': 'OpenDyslexic',
                        '--highligh_font': 'OpenDyslexic',
                    })
                });
            }, 700);
        }
        if (accorAccessibilityStatus.letterSpacing == 'large') {
            body.addClass('readable_font');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--font': 'OpenDyslexic',
                        '--highligh_font': 'OpenDyslexic',
                    })
                });
            }, 700);
        }
        if (reset) {
            body.removeClass('accessibility__BW');
            body.removeClass('accessibility__BY');
            body.removeClass('accessibility__YB');
            body.removeClass('readable_font');
            body.removeClass('larger_font');
            setTimeout(function () {
                cssVars({
                    include: '[data-polyfill]', variables: ({
                        '--font': '"PT Sans", "arial", "Helvetica", sans-serif',
                        '--highligh_font': '"Noto Serif", serif',
                        '--submenu-bg': 'rgba(255, 255, 255, .95)',
                        '--sp-bg': 'rgba(41, 40, 41, 0.5)',
                        '--hlight-sp-bg': 'rgba(0, 0, 0, 0.7)',
                        '--hlight-border-anchor': '#a06e60',
                        '--charcoal-gray': '#292829',
                        '--dark-peach': '#d8946d',
                        '--midnight-blue': '#050034',
                        '--filters-bg': '#f8f8f8',
                        '--white': '#ffffff',
                    })
                });
            }, 510);
        }
        saveAccessibilityStatus();
    }


    function mantis_language_manager_on_focus() {
        if (window.is_phone) {
            $('.languages_menu a.actual_lang').on('click', function () {
                $('.langs_list').css({
                    'display': 'block',
                });
            });
        } else {
            //This function is for accessibility
            //Languages selector
            $('.languages_menu a.actual_lang').focus(function () {
                $('.langs_list').css({
                    'display': 'block',
                });
            });
        }

        $('.other_langs_list li:last-child a').focusout(function () {
            $('.langs_list').removeAttr('style');
        });
    }

    function mantis_submenu_on_focus() {
        //This function is for accessibility
        $('.menu_box ul.menu > li').each(function () {
            $(this).find('> a').focus(function () {
                var wrapper = $(this).parent(),
                    subMenu = wrapper.find('.sub_menu');
                subMenu.css({
                    'display': 'block'
                })
            });
            $(this).find('.sub_menu li a').focus(function () {
                var wrapper = $(this).parent().parent();
                wrapper.css({
                    'display': 'block'
                })
            });
            $(this).find('.sub_menu li:last-child a').focusout(function () {
                var wrapper = $(this).parent().parent();
                wrapper.removeAttr('style')
            });
        });
    }


    function accessibilityPanel() {
        var body = $('body');
        $('#bw').on('click', function () {
            accorAccessibilityStatus.color = 'bw';
            applyAccessibilityStatus();
        });
        $('#by').on('click', function () {
            accorAccessibilityStatus.color = 'by';
            applyAccessibilityStatus();
        });
        $('#yb').on('click', function () {
            accorAccessibilityStatus.color = 'yb';
            applyAccessibilityStatus();
        });
        $('#larger_font').on('click', function () {
            accorAccessibilityStatus.fontSize = 'large';
            applyAccessibilityStatus();
            if (jQuery('html').hasClass('special_offers')) {
                jQuery('.special_offers_wrapper').isotope('layout');
            }
        });
        $('#larger_spacing').on('click', function () {
            accorAccessibilityStatus.letterSpacing = 'large';
            applyAccessibilityStatus();
            if (jQuery('html').hasClass('special_offers')) {
                jQuery('.special_offers_wrapper').isotope('layout');
            }
        });
        $('#reset').on('click', function () {
            accorAccessibilityStatus = {
                color: 'default',
                fontSize: 'normal',
                letterSpacing: 'normal'
            };
            applyAccessibilityStatus(true);
            if (jQuery('html').hasClass('special_offers')) {
                jQuery('.special_offers_wrapper').isotope('layout');
            }
        });
        $('#hotel_destinations').on('keypress', function (e) {
            if (e.keyCode == 13) {
                $('#hotel_destinations').trigger('click');
            }
        });
    }

    function fixDiv() {
        var $cache = $('#hotel_menu');
        var slideshow_height = $('#slideshow_wrapper').height();
        if ($(window).scrollTop() >= slideshow_height)
            $cache.addClass('fixed_menu');
        else
            $cache.removeClass('fixed_menu');
    }

    function manageForms() {

        if ($("body.page-template-template-contact_us").length) {
            var tab = $('.tablist a');

            tab.click(function () {
                if (!($(this).hasClass('active'))) {
                    $('.tablist a').removeClass('active');
                    $(this).addClass('active');

                    var type_form = $(this).attr("data-form");
                    $('.custom_form').removeClass('active');
                    $('#' + type_form).addClass('active');
                }
            });
        }
    }

    function manage_form_under18() {
        //Traveller form
        var selectHotelForm = $("form#hotel_form select#form_under_18");
        var textHotelForm = $("form#hotel_form input#form_under_18_age");

        if (selectHotelForm.length !== 0 && textHotelForm.length !== 0) {
            selectHotelForm.on("change", function () {
                if (selectHotelForm.value === "yes") {
                    textHotelForm.required = true;
                    textHotelForm.parent().addClass('required');
                } else {
                    textHotelForm.required = false;
                    textHotelForm.parent().removeClass('required');
                }
            });
        }

        //Traveller form
        var selectTravellerForm = $("form#traveller_form select#form_under_18");
        var textTravellerForm = $("form#traveller_form input#form_under_18_age");

        if (selectTravellerForm.length !== 0 && textTravellerForm.length !== 0) {
            selectTravellerForm.on("change", function () {
                if (selectTravellerForm.value === "yes") {
                    textTravellerForm.required = true;
                    textTravellerForm.parent().addClass('required');
                } else {
                    textTravellerForm.required = false;
                    textTravellerForm.parent().removeClass('required');
                }
            });
        }


        //Agent form
        var selectAgentForm = $("form#agent_form select#form_under_18");
        var textAgentForm = $("form#agent_form input#form_under_18_age");

        if (selectAgentForm.length !== 0 && textAgentForm.length !== 0) {
            selectAgentForm.on("change", function () {
                if (selectAgentForm.value === "yes") {
                    textAgentForm.required = true;
                    textAgentForm.parent().addClass('required');
                } else {
                    textAgentForm.required = false;
                    textAgentForm.parent().removeClass('required');
                }
            });
        }
    }

    function contact_form_referrer() {
        if ($('body').hasClass('hotel_form') || $('body').hasClass('contact_form')) {
            var cookieValue = Cookies.get('mantis_contact_referrer');
            var documentValue = (document.referrer || '').split('?')[0];
            var urlValue = location.href.split('?')[0];
            var currentReferrer = documentValue;

            if (documentValue !== '' && documentValue !== cookieValue && documentValue !== urlValue) {
                Cookies.set('mantis_contact_referrer', documentValue, {expires: 365, path: '/'});
            } else {
                currentReferrer = cookieValue || urlValue;
            }
            console.log('currentReferrer', currentReferrer);
            $('input[name="referrer"]').val(currentReferrer);
        }
    }

    function booking_popup() {
        var bpopup = document.querySelector('#booking_popup');
        var bpopupClose = document.querySelector('#booking_popup .booking_popup-close');
        var bsubmit = document.querySelector('.bf_submit input');

        bpopupClose.addEventListener('click', function () {
            bpopup.style.display = 'none';
        });
    }

    ///////////////////////////////////
    ///////  END FUNCTIONS     /////////
    ///////////////////////////////////

    // WINDOW LOAD
    jQuery(window).load(function () {
        // custom_scroll
        custom_scroll();
        //Special offers
        special_offers();
        //Accessibility mode
        applyAccessibilityStatus();
        accessibilityPanel();
        if (!is_mobile) {
            sameHeightForAllElements('#press_release .press .content', true);
        }
    });

    // WINDOW RESIZE
    jQuery(window).resize(function () {
        // detecting screen dimensions
        refresh_size_queries();
        // check on resize
        box_filters_manage();
        // custom_scroll
        custom_scroll();
        //hotel minigallery section
        minigallery_hotel();
    });

    // WINDOW SCROLL
    jQuery(window).scroll(function () {
        // hotel menu scroll
        hotel_menu_scroll();
        fixDiv();
    });


    /////////////// DOM READY
    $(document).ready(function () {
        // detecting screen dimensions
        refresh_size_queries();

        fixDiv();
        // lazy
        lazy();

        mantis_language_manager_on_focus();
        mantis_submenu_on_focus();
        booking_popup();
        manageForms();
        // open_close_viewmore
        open_close_viewmore();
        // select drop downs
        select_dd();
        // tabs
        select_tabs();
        // scroll function
        btn_scroll();
        // mobile view more
        mobile_view_more();
        // SLIDESHOW
        doSlideshow('#slideshow .cycle');

        //mobile carousel special offers
        carousel_preview_offers();

        // open mobile menu
        mobile_menu_open();

        // box filters
        box_filters_manage();

        // hotel gallery
        gallery_hotel();
        //hotel minigallery section
        minigallery_hotel();
        // hotel menu scroll
        hotel_menu_scroll();

        // large_carousel
        large_carousel();
        // simple carousel
        // simple_carousel();
        // mobile carousel
        mobile_carousel();
        // slick tabs
        slick_tabs();

        // rooms
        popup_fancy();

        // google map
        google_map();

        // other_hotels
        other_posts();

        // hotels filters
        hotels_filters_counters();
        hotels_filters();

        // experiences filters
        experiences_filters();

        // home pop_up
        pop_up();

        // hotel_form_manager
        hotel_form_manager();

        // offer_form_manager
        offer_form_manager();

        // traveller_form_manager
        traveller_form_manager();

        // agent_form_manager
        agent_form_manager();

        // landing_page_form_manager
        landing_page_form_manager();

        // general_form_manager
        general_form_manager();

        // contact us form
        contact_form_manager();

        partner_form_manager();

        // awards carousel
        awards_carousel();

        //Other offers single CPT
        other_offers();

        //Hotel gallery mobile
        hotel_gallery_mobile();

        //Handle contact form referrer
        contact_form_referrer()

        manage_form_under18(); 
        // console.log(window.performance.memory);

    });

})(jQuery);